import React from 'react';

/**
 * "This is my contest entry" (Jenn, 2026-10-24) — shown on a Hive post or
 * comment box only while a members-only contest is running. One contest:
 * just the tick box. Several: tick, then choose which one.
 * value = contest id or '' (not an entry).
 */
export default function ContestEntryBox({ contests, value, onChange }) {
  if (!contests || contests.length === 0) return null;
  const checked = !!value;
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-reset-brown">
      <label className="flex items-center gap-1.5 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked ? contests[0].id : '')}
          className="accent-reset-terracotta"
        />
        🏆 This is my contest entry{contests.length === 1 ? ` (${contests[0].name})` : ''}
      </label>
      {checked && contests.length > 1 && (
        <select
          value={value}
          onChange={e => onChange(e.target.value)}
          aria-label="Which contest"
          className="border border-gray-200 rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-2 focus:ring-reset-terracotta"
        >
          {contests.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      )}
    </div>
  );
}
